// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2FoS5","productName":"Table_productName__TZiI1"};